var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90543 4.40486L18.8221 8.8632C22.8221 10.8632 22.8221 14.1341 18.8221 16.1341L9.90543 20.5924C3.90543 23.5924 1.45751 21.1341 4.45751 15.1445L5.36376 13.3424C5.59293 12.8841 5.59293 12.1236 5.36376 11.6653L4.45751 9.85278C1.45751 3.8632 3.91584 1.40486 9.90543 4.40486Z",
    stroke: "#D29A08",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M5.66602 12.5H11.2911",
    stroke: "#D29A08",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b2ea235cbcd8b4fb2c809bf5d49868fd.svg";
export { ForwardRef as ReactComponent };